(function () {
  const SAMPLE_REVIEWS = [
    {
      id: 'sample-1',
      name: 'Saldeina',
      city: 'Santo Andre',
      province: 'SP',
      rating: 5,
      title: 'Maravilhosa.',
      body: 'Simplesmente tudo. Roupas maravilhosas, lindas e perfeitas.',
      createdAt: '2026-04-03',
      verified: true,
      productTitle: ''
    },
    {
      id: 'sample-2',
      name: 'Sivanil',
      city: 'Bauru',
      province: 'SP',
      rating: 5,
      title: 'Muito boa, amei.',
      body: 'De tudo: produto, preco e atendimento.',
      createdAt: '2026-04-03',
      verified: true,
      productTitle: ''
    },
    {
      id: 'sample-3',
      name: 'Nivaldo',
      city: 'Rio Pardo de Minas',
      province: 'MG',
      rating: 5,
      title: 'Excelente.',
      body: 'A entrega foi super rapida. Super indico.',
      createdAt: '2026-04-01',
      verified: true,
      productTitle: ''
    },
    {
      id: 'sample-4',
      name: 'Bettina',
      city: 'Imbituba',
      province: 'SC',
      rating: 5,
      title: 'Otima.',
      body: 'Qualidade, prazo de entrega e atendimento.',
      createdAt: '2026-03-31',
      verified: true,
      productTitle: ''
    }
  ];

  const DATE_FORMATTER = new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });

  function initAll(scope) {
    const roots = (scope || document).querySelectorAll('[data-datitia-reviews-root]');
    roots.forEach(initSection);
  }

  function initSection(root) {
    if (root.dataset.cacheInitialized === 'true') return;
    root.dataset.cacheInitialized = 'true';

    const section = root.closest('.dt-reviews');
    if (!section) return;

    const config = {
      gridBase: root.dataset.gridBase || 'https://cdn.judge.me/widgets/reviews_grid_widget_data',
      cacheBase: root.dataset.cacheBase || 'https://cache.judge.me/widgets/shopify',
      shopDomain: (root.dataset.shopDomain || '').trim(),
      apiToken: (root.dataset.apiToken || '').trim(),
      perPage: Math.max(1, Number(root.dataset.perPage || 6)),
      cachePagesToLoad: Math.max(1, Math.min(80, Number(root.dataset.cachePagesToLoad || 24))),
      storeName: root.dataset.storeName || '',
      designMode: root.dataset.designMode === 'true',
      reviewScope: root.dataset.reviewScope || 'store',
      fallbackCount: Number(root.dataset.shopReviewsCount || 0),
      fallbackRating: Number(root.dataset.shopReviewsRating || 0),
      emptyHeading: root.dataset.emptyHeading || 'Nenhuma avaliacao encontrada',
      emptyText: root.dataset.emptyText || 'Tente outro filtro.'
    };

    const refs = {
      toolbar: root.querySelector('.dt-toolbar'),
      feedback: root.querySelector('[data-feedback]'),
      resultsSummary: root.querySelector('[data-results-summary]'),
      loading: root.querySelector('[data-loading]'),
      grid: root.querySelector('[data-reviews-grid]'),
      cacheWidget: root.querySelector('[data-cache-widget]'),
      empty: root.querySelector('[data-empty-state]'),
      pagination: root.querySelector('[data-pagination]'),
      search: root.querySelector('[data-reviews-search]'),
      ratingButtons: root.querySelectorAll('[data-rating-filter]'),
      averageScore: section.querySelector('[data-average-score]'),
      averageStars: section.querySelector('[data-average-stars]'),
      totalCopy: section.querySelector('[data-total-copy]'),
      ratingFills: section.querySelectorAll('[data-rating-fill]'),
      ratingCounts: section.querySelectorAll('[data-rating-count]')
    };

    const state = {
      page: 1,
      activeRating: '5',
      searchTerm: '',
      reviews: [],
      totalCount: 0,
      loadedRating: 'all',
      remotePage: 1,
      remoteTotalPages: 1,
      usingSample: false,
      renderMode: 'cards'
    };

    refs.ratingButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const rating = button.dataset.ratingFilter || 'all';
        if (rating === state.activeRating) return;
        state.activeRating = rating;
        state.page = 1;
        refs.ratingButtons.forEach((item) => item.classList.toggle('is-active', item === button));
        loadReviewsForRating(rating);
      });
    });

    if (refs.search) {
      refs.search.addEventListener('input', () => {
        state.searchTerm = refs.search.value.trim().toLowerCase();
        state.page = 1;
        renderReviews();
      });
    }

    load();

    async function load() {
      setLoading(true);
      hideFallbackWidget();

      if (!config.shopDomain || !config.apiToken) {
        renderSample(
          'Preencha o Shop domain e o Public API Token do Judge.me nas configuracoes da secao para carregar as avaliacoes reais.',
          true
        );
        setLoading(false);
        return;
      }

      try {
        const parsed = await resolveReviewsPayload(config, 'all');

        if (parsed.reviews.length) {
          state.usingSample = false;
          state.renderMode = 'cards';
          state.reviews = parsed.reviews;
          state.totalCount = Number(parsed.totalCount || parsed.reviews.length || 0);
          state.loadedRating = 'all';
          state.remotePage = Number(parsed.currentPage || 1);
          state.remoteTotalPages = Number(parsed.totalPages || 1);
          setToolbarVisible(true);
          setFeedback(parsed.notice || '');
          updateSummaryFromReviews(parsed.reviews, config, parsed);
          renderReviews();
        } else if (parsed.widgetHtml) {
          state.usingSample = false;
          state.renderMode = 'widget';
          state.reviews = [];
          setToolbarVisible(false);
          updateSummaryFromFallback(config);
          setFeedback('');
          showFallbackWidget(parsed.widgetHtml, config.reviewScope === 'store');
          refs.grid.innerHTML = '';
          refs.empty.hidden = true;
          refs.resultsSummary.textContent = '';
          renderPagination(1, 0);
        } else {
          throw new Error('cache_empty');
        }
      } catch (error) {
        console.error('[Datitia Reviews] Failed to load Judge.me cache data', error);

        if (config.designMode) {
          renderSample(buildErrorMessage(error), false);
        } else {
          state.usingSample = false;
          state.renderMode = 'empty';
          state.reviews = [];
          setToolbarVisible(false);
          updateSummaryFromFallback(config);
          setFeedback(buildErrorMessage(error));
          showEmpty(config.emptyHeading, config.emptyText);
          renderPagination(1, 0);
        }
      } finally {
        setLoading(false);
      }
    }

    async function loadReviewsForRating(rating) {
      if (state.usingSample || state.renderMode !== 'cards') {
        renderReviews();
        return;
      }

      setLoading(true);

      try {
        const parsed = await fetchGridReviewsPages(config, rating);
        state.reviews = parsed.reviews;
        state.totalCount = Number(parsed.totalCount || parsed.reviews.length || 0);
        state.loadedRating = rating;
        state.remotePage = Number(parsed.currentPage || 1);
        state.remoteTotalPages = Number(parsed.totalPages || 1);
        setFeedback('');
      } catch (error) {
        console.error('[Datitia Reviews] Failed to load rating filter', error);
        setFeedback('Não foi possível carregar esse filtro agora. Tente novamente em instantes.');
      } finally {
        setLoading(false);
        renderReviews();
      }
    }

    function renderSample(message, needsConfig) {
      state.usingSample = true;
      state.renderMode = 'cards';
      state.reviews = SAMPLE_REVIEWS.slice();
      state.totalCount = SAMPLE_REVIEWS.length;
      setToolbarVisible(true);
      setFeedback(
        needsConfig
          ? message
          : `${message} Exibindo uma previa visual para voce continuar ajustando o layout no editor.`
      );
      updateSummaryFromReviews(SAMPLE_REVIEWS, config);
      renderReviews();
      renderPagination(1, 1);
    }

    function renderReviews() {
      hideFallbackWidget();

      const filtered = state.reviews.filter((review) => {
        return matchesRating(review, state.activeRating) && matchesSearch(review, state.searchTerm);
      });

      const totalPages = Math.max(
        1,
        Math.ceil(Math.max(state.totalCount && !state.searchTerm ? state.totalCount : filtered.length, 1) / config.perPage)
      );
      if (state.page > totalPages) state.page = totalPages;

      const start = (state.page - 1) * config.perPage;
      const pageReviews = filtered.slice(start, start + config.perPage);

      refs.grid.innerHTML = pageReviews.map((review) => renderCard(review, config.storeName)).join('');

      if (!pageReviews.length) {
        showEmpty(config.emptyHeading, config.emptyText);
      } else {
        refs.empty.hidden = true;
      }

      if (refs.resultsSummary) {
        const scopeLabel = config.reviewScope === 'store' ? 'avaliacoes da loja' : 'avaliacoes';
        const sourceLabel = state.usingSample ? ' Previa visual.' : '';
        const pageLabel = filtered.length ? ` Pagina ${state.page} de ${totalPages}.` : '';
        const searchLabel = state.searchTerm ? ` Busca local por "${state.searchTerm}".` : '';
        const loadedLabel =
          !state.usingSample && state.totalCount > filtered.length && state.activeRating === 'all' && !state.searchTerm
            ? `${filtered.length} de ${formatNumber(state.totalCount)} ${scopeLabel} carregadas.`
            : `${filtered.length} ${scopeLabel} encontradas.`;
        refs.resultsSummary.textContent = `${loadedLabel}${pageLabel}${searchLabel}${sourceLabel}`;
      }

      renderPagination(state.page, filtered.length ? totalPages : 0);
    }

    function renderPagination(currentPage, totalPages) {
      if (!refs.pagination) return;

      if (!totalPages || totalPages <= 1 || state.usingSample) {
        refs.pagination.hidden = true;
        refs.pagination.innerHTML = '';
        return;
      }

      refs.pagination.hidden = false;
      const buttons = [];
      const start = Math.max(1, currentPage - 2);
      const end = Math.min(totalPages, currentPage + 2);

      if (currentPage > 1) {
        buttons.push(createPageButton('Anterior', currentPage - 1, false));
      }

      for (let page = start; page <= end; page += 1) {
        buttons.push(createPageButton(String(page), page, page === currentPage));
      }

      if (currentPage < totalPages) {
        buttons.push(createPageButton('Proxima', currentPage + 1, false));
      }

      refs.pagination.innerHTML = buttons.join('');
      refs.pagination.querySelectorAll('[data-page]').forEach((button) => {
        button.addEventListener('click', async () => {
          const nextPage = Number(button.dataset.page);
          if (!nextPage || nextPage === state.page) return;
          state.page = nextPage;
          await ensureReviewsForPage(nextPage);
          renderReviews();
        });
      });
    }

    async function ensureReviewsForPage(page) {
      if (state.usingSample || state.renderMode !== 'cards' || state.searchTerm) return;

      const neededReviews = page * config.perPage;
      const filteredReviews = state.reviews.filter((review) => matchesRating(review, state.activeRating));
      if (filteredReviews.length >= neededReviews) return;
      if (state.remotePage >= state.remoteTotalPages) return;

      setLoading(true);

      try {
        while (
          state.reviews.filter((review) => matchesRating(review, state.activeRating)).length < neededReviews &&
          state.remotePage < state.remoteTotalPages
        ) {
          const parsed = await fetchGridReviewsPage(config, state.loadedRating, state.remotePage + 1);
          mergeReviews(parsed.reviews);
          state.totalCount = Number(parsed.totalCount || state.totalCount || state.reviews.length || 0);
          state.remotePage = Number(parsed.currentPage || state.remotePage + 1);
          state.remoteTotalPages = Number(parsed.totalPages || state.remoteTotalPages || 1);
        }
      } catch (error) {
        console.error('[Datitia Reviews] Failed to load next reviews page', error);
        setFeedback('Não foi possível carregar mais avaliações agora. Tente novamente em instantes.');
      } finally {
        setLoading(false);
      }
    }

    function mergeReviews(nextReviews) {
      const existingIds = new Set(state.reviews.map((review) => review.id));
      nextReviews.forEach((review) => {
        if (!existingIds.has(review.id)) {
          existingIds.add(review.id);
          state.reviews.push(review);
        }
      });
    }

    function setFeedback(message) {
      if (!refs.feedback) return;
      refs.feedback.textContent = message;
      refs.feedback.hidden = !message;
    }

    function setToolbarVisible(isVisible) {
      if (!refs.toolbar) return;
      refs.toolbar.hidden = !isVisible;
      refs.toolbar.style.display = isVisible ? '' : 'none';
    }

    function setLoading(isLoading) {
      if (!refs.loading) return;
      refs.loading.hidden = !isLoading;
    }

    function showEmpty(title, text) {
      if (!refs.empty) return;
      const titleNode = refs.empty.querySelector('h3');
      const textNode = refs.empty.querySelector('p');
      if (titleNode) titleNode.textContent = title;
      if (textNode) textNode.textContent = text;
      refs.empty.hidden = false;
      refs.grid.innerHTML = '';
    }

    function showFallbackWidget(widgetHtml, preferStoreReviews) {
      if (!refs.cacheWidget) return;
      ensureJudgeMePreloader();
      refs.cacheWidget.innerHTML = widgetHtml;
      refs.cacheWidget.classList.toggle('dt-cache-widget--store', Boolean(preferStoreReviews));
      refs.cacheWidget.hidden = false;
      refs.grid.innerHTML = '';

      if (preferStoreReviews) {
        window.setTimeout(() => activateStoreReviewsTab(refs.cacheWidget), 500);
        window.setTimeout(() => activateStoreReviewsTab(refs.cacheWidget), 1500);
      }
    }

    function hideFallbackWidget() {
      if (!refs.cacheWidget) return;
      refs.cacheWidget.hidden = true;
      refs.cacheWidget.innerHTML = '';
      refs.cacheWidget.classList.remove('dt-cache-widget--store');
    }

    function clearSummary() {
      if (refs.averageScore) refs.averageScore.textContent = '--';
      if (refs.averageStars) refs.averageStars.textContent = '★★★★★';
      if (refs.totalCopy) refs.totalCopy.textContent = 'Conecte o Judge.me para carregar as avaliacoes reais.';
      refs.ratingFills.forEach((fill) => {
        fill.style.width = '0%';
      });
      refs.ratingCounts.forEach((count) => {
        count.textContent = '0%';
      });
    }

    function updateSummaryFromFallback(fallbackConfig) {
      if (fallbackConfig.fallbackCount > 0 && fallbackConfig.fallbackRating > 0) {
        if (refs.averageScore) refs.averageScore.textContent = Number(fallbackConfig.fallbackRating).toFixed(1);
        if (refs.averageStars) refs.averageStars.textContent = buildStars(fallbackConfig.fallbackRating);
        if (refs.totalCopy) {
          refs.totalCopy.textContent =
            fallbackConfig.fallbackCount === 1
              ? 'Baseado em 1 avaliacao'
              : `Baseado em ${formatNumber(fallbackConfig.fallbackCount)} avaliacoes`;
        }
        refs.ratingFills.forEach((fill) => {
          fill.style.width = '0%';
        });
        refs.ratingCounts.forEach((count) => {
          count.textContent = '0%';
        });
        return;
      }

      clearSummary();
    }

    function updateSummaryFromReviews(reviews, summaryConfig, payloadSummary) {
      const counts = buildCountsFromReviews(reviews);
      const total = Object.values(counts).reduce((sum, value) => sum + value, 0);
      const officialTotal = Number(
        payloadSummary && (payloadSummary.summaryCount || payloadSummary.totalCount)
          ? payloadSummary.summaryCount || payloadSummary.totalCount
          : 0
      );
      const officialAverage = Number(payloadSummary && payloadSummary.averageRating ? payloadSummary.averageRating : 0);

      if (!total && summaryConfig.fallbackCount > 0 && summaryConfig.fallbackRating > 0) {
        updateSummaryFromFallback(summaryConfig);
        updateOfficialSummary(officialTotal, officialAverage);
        return;
      }

      if (
        summaryConfig.fallbackCount > 0 &&
        summaryConfig.fallbackRating > 0 &&
        total > 0 &&
        total !== summaryConfig.fallbackCount
      ) {
        updateSummaryFromFallback({
          ...summaryConfig,
          fallbackCount: officialTotal || summaryConfig.fallbackCount,
          fallbackRating: officialAverage || summaryConfig.fallbackRating
        });
        updateOfficialSummary(officialTotal, officialAverage);
        return;
      }

      updateSummary(counts);
      updateOfficialSummary(officialTotal, officialAverage);
    }

    function updateOfficialSummary(total, average) {
      if (refs.totalCopy && total) {
        refs.totalCopy.textContent =
          total === 1 ? 'Baseado em 1 avaliação da loja' : `Baseado em ${formatNumber(total)} avaliações da loja`;
      }

      if (average > 0) {
        if (refs.averageScore) refs.averageScore.textContent = average.toFixed(1);
        if (refs.averageStars) refs.averageStars.textContent = buildStars(average);
      }
    }

    function updateSummary(countsByRating) {
      const total = Object.values(countsByRating).reduce((sum, value) => sum + value, 0);
      const weightedTotal = Object.entries(countsByRating).reduce((sum, entry) => {
        return sum + Number(entry[0]) * Number(entry[1]);
      }, 0);
      const average = total ? (weightedTotal / total).toFixed(1) : '0.0';

      if (refs.averageScore) refs.averageScore.textContent = average;
      if (refs.averageStars) refs.averageStars.textContent = buildStars(Number(average));
      if (refs.totalCopy) {
        refs.totalCopy.textContent = total === 1 ? 'Baseado em 1 avaliacao' : `Baseado em ${formatNumber(total)} avaliacoes`;
      }

      refs.ratingFills.forEach((fill) => {
        const rating = Number(fill.dataset.ratingFill);
        const count = countsByRating[rating] || 0;
        const percent = total ? Math.round((count / total) * 100) : 0;
        fill.style.width = `${percent}%`;
      });

      refs.ratingCounts.forEach((countNode) => {
        const rating = Number(countNode.dataset.ratingCount);
        const count = countsByRating[rating] || 0;
        const percent = total ? Math.round((count / total) * 100) : 0;
        countNode.textContent = `${percent}%`;
      });
    }
  }

  async function fetchCachePayload(config, mode, page) {
    const query = new URLSearchParams({
      public_token: config.apiToken,
      all_reviews_rating: '1',
      all_reviews_count: '1'
    });

    if (mode === 'featured_carousel') {
      query.set('featured_carousel', '1');
    } else if (mode === 'all_reviews_js_based') {
      query.set('all_reviews_js_based', '1');
    } else {
      query.set('all_reviews_page', String(page || 1));
    }

    const url = `${config.cacheBase}/${encodeURIComponent(config.shopDomain)}?${query.toString()}`;
    const response = await fetch(url);

    if (!response.ok) {
      const error = new Error(`Cache request failed with status ${response.status}`);
      error.status = response.status;
      throw error;
    }

    return response.json();
  }

  async function resolveReviewsPayload(config, rating) {
    try {
      const gridPayload = await fetchGridReviewsPages(config, rating);
      if (gridPayload.reviews.length) {
        try {
          const summaryPayload = config.apiToken ? await fetchCachePayload(config, 'all_reviews_js_based', 1) : null;
          gridPayload.averageRating = Number(
            summaryPayload && summaryPayload.all_reviews_rating ? summaryPayload.all_reviews_rating : 0
          );
          gridPayload.summaryCount = Number(
            summaryPayload && summaryPayload.all_reviews_count ? summaryPayload.all_reviews_count : 0
          );
        } catch (error) {
          console.warn('[Datitia Reviews] Cache summary endpoint failed', error);
        }

        return gridPayload;
      }
    } catch (error) {
      console.warn('[Datitia Reviews] Grid data endpoint failed, falling back to cache', error);
    }

    return resolveCachePayload(config);
  }

  async function fetchGridReviewsPages(config, rating) {
    const reviewsById = new Map();
    let totalCount = 0;
    let totalPages = 1;
    let currentPage = 1;

    for (let page = 1; page <= config.cachePagesToLoad && page <= totalPages; page += 1) {
      const parsed = await fetchGridReviewsPage(config, rating, page);
      totalCount = Number(parsed.totalCount || totalCount || 0);
      totalPages = Math.max(1, Number(parsed.totalPages || totalPages || 1));
      currentPage = Number(parsed.currentPage || page);

      const reviews = parsed.reviews;
      const previousSize = reviewsById.size;
      reviews.forEach((review) => {
        reviewsById.set(review.id, review);
      });

      if (!reviews.length || reviewsById.size === previousSize) break;
    }

    return {
      reviews: sortReviewsForFirstImpression(Array.from(reviewsById.values())),
      widgetHtml: '',
      notice: '',
      totalCount,
      totalPages,
      currentPage
    };
  }

  async function fetchGridReviewsPage(config, rating, page) {
    const query = new URLSearchParams({
      widget_type: 'all-reviews-widget-v2025',
      page: String(page || 1),
      review_type: config.reviewScope === 'store' ? 'shop-reviews' : 'all-reviews',
      sort_by: 'created_at',
      sort_dir: 'desc',
      widget_theme: 'default',
      shop_domain: config.shopDomain,
      platform: 'shopify'
    });

    if (rating && rating !== 'all') {
      query.set('filter_rating', String(rating));
    }

    const response = await fetch(`${config.gridBase}?${query.toString()}`);

    if (!response.ok) {
      const error = new Error(`Grid reviews request failed with status ${response.status}`);
      error.status = response.status;
      throw error;
    }

    const payload = await response.json();
    const pagination = payload.pagination || {};

    return {
      reviews: normalizeGridReviews(payload, config),
      totalCount: Number(pagination.total_count || payload.number_of_shop_reviews || 0),
      totalPages: Math.max(1, Number(pagination.total_pages || 1)),
      currentPage: Number(pagination.current_page || page || 1)
    };
  }

  function sortReviewsForFirstImpression(reviews) {
    return reviews.slice().sort((first, second) => {
      const ratingDiff = Number(second.rating || 0) - Number(first.rating || 0);
      if (ratingDiff) return ratingDiff;

      const firstDate = new Date(first.createdAt).getTime() || 0;
      const secondDate = new Date(second.createdAt).getTime() || 0;
      return secondDate - firstDate;
    });
  }

  async function resolveCachePayload(config) {
    const attempts = ['all_reviews', 'featured_carousel'];
    let lastError = null;

    for (const mode of attempts) {
      try {
        const parsed =
          mode === 'all_reviews'
            ? await fetchAllReviewsPages(config)
            : parseCachePayload(await fetchCachePayload(config, mode, 1), config, mode);

        if (parsed.reviews.length || parsed.widgetHtml) {
          return parsed;
        }
      } catch (error) {
        lastError = error;
      }
    }

    if (lastError) throw lastError;
    throw new Error('cache_empty');
  }

  async function fetchAllReviewsPages(config) {
    let widgetHtml = '';
    let widgetMessage = '';
    const reviewsById = new Map();

    for (let page = 1; page <= config.cachePagesToLoad; page += 1) {
      let payload;

      try {
        payload = await fetchCachePayload(config, 'all_reviews', page);
      } catch (error) {
        if (page === 1) throw error;
        break;
      }

      const parsed = parseCachePayload(payload, config, 'all_reviews');

      if (page === 1) {
        widgetHtml = parsed.widgetHtml;
        widgetMessage = parsed.widgetMessage;
      }

      const previousSize = reviewsById.size;
      parsed.reviews.forEach((review) => {
        const key = review.id || `${review.name}-${review.createdAt}-${review.title}`;
        reviewsById.set(key, review);
      });

      if (!parsed.reviews.length || reviewsById.size === previousSize) break;
    }

    return {
      reviews: Array.from(reviewsById.values()),
      widgetHtml,
      widgetMessage
    };
  }

  function parseCachePayload(payload, config, mode) {
    if (mode === 'featured_carousel') {
      const widgetHtml = `${payload.html_miracle || ''}${payload.featured_carousel || ''}`;
      const reviews = parseCarouselReviews(payload.featured_carousel || '', config);
      return {
        reviews,
        widgetHtml,
        notice:
          reviews.length && config.reviewScope === 'store'
            ? 'Mostrando as avaliacoes que o cache do Reviews Carousel devolveu para a loja. Se voce quiser uma listagem completa, a Reviews Page oficial do Judge.me pode exigir configuracao adicional ou plano compativel.'
            : '',
        widgetMessage:
          'O cache do Judge.me carregou o Reviews Carousel. Exibindo o widget oficial enquanto mantemos o layout conectado aos dados do app.'
      };
    }

    const widgetBody = `${payload.all_reviews_header || ''}${payload.all_reviews || ''}`;
    const widgetHtml = widgetBody ? `${payload.html_miracle || ''}${widgetBody}` : '';
    const reviews = parseCacheReviews(payload.all_reviews || '', config);
    return {
      reviews,
      widgetHtml,
      widgetMessage:
        'O cache do Judge.me carregou a Reviews Page oficial. Exibindo o widget oficial enquanto mantemos a pagina conectada aos dados do app.'
    };
  }

  function parseCacheReviews(html, config) {
    if (!html || typeof DOMParser === 'undefined') return [];

    const parser = new DOMParser();
    const documentFragment = parser.parseFromString(`<div>${html}</div>`, 'text/html');
    const nodes = Array.from(documentFragment.querySelectorAll('.jdgm-rev'));

    return nodes
      .map((node, index) => normalizeCacheReview(node, index, config))
      .filter(Boolean)
      .filter((review) => {
        if (config.reviewScope === 'all') return true;
        return isStoreReview(review, config);
      });
  }

  function normalizeGridReviews(payload, config) {
    const reviews = Array.isArray(payload.reviews) ? payload.reviews : [];

    return reviews
      .map((item, index) => {
        const productTitle = safeText(item.product_title);
        const isStoreReview =
          Number(item.product_id || 0) === 0 ||
          item.product_url === '/' ||
          normalizeText(productTitle) === normalizeText(config.storeName);

        return {
          id: item.uuid || `grid-review-${payload.current_page || 1}-${index + 1}`,
          name: safeText(item.reviewer_name) || 'Cliente',
          city: safeText(item.location),
          province: '',
          rating: clampRating(item.rating),
          title: safeText(item.title),
          body: safeText(item.body),
          createdAt: safeText(item.created_at),
          verified: Boolean(item.verified_buyer),
          productTitle,
          storeName: config.storeName,
          isStoreReview,
          cfAnswers: Array.isArray(item.cf_answers)
            ? item.cf_answers.map((answer) => ({
                question: safeText(answer.question || answer.cf_question || answer.label),
                value: safeText(answer.value || answer.answer)
              }))
            : []
        };
      })
      .filter((review) => review.title || review.body || review.rating)
      .filter((review) => {
        if (config.reviewScope === 'all') return true;
        return isStoreReview(review, config);
      });
  }

  function normalizeCacheReview(node, index, config) {
    const ratingNode = node.querySelector('.jdgm-rev__rating');
    const productLink = node.querySelector('.jdgm-rev__prod-link');
    const authorNode = node.querySelector('.jdgm-rev__author');
    const locationNode = node.querySelector('.jdgm-rev__location');
    const titleNode = node.querySelector('.jdgm-rev__title');
    const bodyNode = node.querySelector('.jdgm-rev__body');
    const timestampNode = node.querySelector('.jdgm-rev__timestamp');

    const productTitle = safeText(productLink && productLink.textContent);
    const body = safeText(bodyNode && bodyNode.textContent);
    const title = safeText(titleNode && titleNode.textContent);
    const rating = clampRating(ratingNode && ratingNode.getAttribute('data-score'));
    const isStoreReview =
      node.classList.contains('jdgm--shop-review') ||
      node.classList.contains('jdgm-rev--shop') ||
      node.getAttribute('data-review-type') === 'shop_review' ||
      node.getAttribute('data-product-id') === 'shop_review' ||
      normalizeText(productTitle) === 'your shop' ||
      normalizeText(productTitle) === normalizeText(config.storeName) ||
      !productTitle;

    if (!title && !body && !rating) return null;

    return {
      id: node.getAttribute('data-review-id') || `cache-review-${index + 1}`,
      name: safeText(authorNode && authorNode.textContent) || 'Cliente',
      city: safeText(locationNode && locationNode.textContent),
      province: '',
      rating,
      title,
      body,
      createdAt: safeText(timestampNode && timestampNode.getAttribute('data-content')),
      verified:
        node.getAttribute('data-verified-buyer') === 'true' ||
        Boolean(node.querySelector('.jdgm-rev__buyer-badge')),
      productTitle,
      storeName: config.storeName,
      isStoreReview
    };
  }

  function parseCarouselReviews(html, config) {
    if (!html || typeof DOMParser === 'undefined') return [];

    const parser = new DOMParser();
    const documentFragment = parser.parseFromString(`<div>${html}</div>`, 'text/html');
    const nodes = Array.from(documentFragment.querySelectorAll('.jdgm-carousel-item'));

    return nodes
      .map((node, index) => normalizeCarouselReview(node, index, config))
      .filter(Boolean)
      .filter((review) => {
        if (config.reviewScope === 'all') return true;
        return isStoreReview(review, config);
      });
  }

  function normalizeCarouselReview(node, index, config) {
    const rating = clampRating(
      node.querySelectorAll(
        '.jdgm-carousel-item__review-rating .jdgm-star.jdgm--on, .jdgm-carousel-item__review-rating .jdgm-star.jdgm--full'
      ).length
    );
    const title = safeText(
      (node.querySelector('.jdgm-carousel-item__review-title') || node.querySelector('.jdgm-carousel-item__review'))
        && (node.querySelector('.jdgm-carousel-item__review-title') || node.querySelector('.jdgm-carousel-item__review')).textContent
    );
    const body = safeText(node.querySelector('.jdgm-carousel-item__review-body') && node.querySelector('.jdgm-carousel-item__review-body').textContent);
    const author = safeText(
      (node.querySelector('.jdgm-carousel-item__reviewer-name') || node.querySelector('.jdgm-carousel-item__reviewer'))
        && (node.querySelector('.jdgm-carousel-item__reviewer-name') || node.querySelector('.jdgm-carousel-item__reviewer')).textContent
    );
    const productTitle = safeText(
      (node.querySelector('.jdgm-carousel-item__product-title') || node.querySelector('.jdgm-carousel-item__product'))
        && (node.querySelector('.jdgm-carousel-item__product-title') || node.querySelector('.jdgm-carousel-item__product')).textContent
    );
    const timestampNode = node.querySelector('.jdgm-carousel-item__timestamp');
    const createdAt = safeText(
      (timestampNode && timestampNode.getAttribute('data-content')) || (timestampNode && timestampNode.textContent)
    );
    const isStoreReview =
      node.classList.contains('jdgm--shop-review') ||
      node.classList.contains('jdgm-carousel-item--shop') ||
      normalizeText(productTitle) === 'your shop' ||
      normalizeText(productTitle) === normalizeText(config.storeName) ||
      !productTitle;

    if (!title && !body && !rating) return null;

    return {
      id: node.getAttribute('data-review-id') || `carousel-review-${index + 1}`,
      name: author || 'Cliente',
      city: '',
      province: '',
      rating,
      title,
      body,
      createdAt,
      verified: Boolean(
        node.querySelector('.jdgm-carousel-item__verified-badge') ||
          node.querySelector('.jdgm-carousel-item__reviewer-badge')
      ),
      productTitle,
      storeName: config.storeName,
      isStoreReview
    };
  }

  function isStoreReview(review, config) {
    if (typeof review.isStoreReview === 'boolean') {
      return review.isStoreReview;
    }

    const productText = normalizeText(review.productTitle);
    const storeName = normalizeText(config.storeName);

    if (!productText) return true;
    if (productText === 'your shop') return true;
    if (storeName && productText === storeName) return true;

    return false;
  }

  function activateStoreReviewsTab(widget) {
    if (!widget) return;

    const tabCandidates = Array.from(
      widget.querySelectorAll('.jdgm-subtab__name, .jdgm-subtab, [role="tab"], button, a')
    );

    const storeTab = tabCandidates.find((candidate) => {
      const label = normalizeText(candidate.textContent);
      return label.includes('shop reviews') || label.includes('store reviews') || label.includes('avaliacoes da loja');
    });

    if (storeTab && !storeTab.classList.contains('jdgm--active')) {
      storeTab.click();
    }
  }

  function matchesRating(review, activeRating) {
    if (!activeRating || activeRating === 'all') return true;
    return String(review.rating) === String(activeRating);
  }

  function matchesSearch(review, term) {
    if (!term) return true;
    const haystack = [review.name, review.city, review.province, review.title, review.body, review.productTitle]
      .join(' ')
      .toLowerCase();

    return haystack.includes(term);
  }

  function renderCard(review, storeName) {
    const lines = buildAnswerLines(review);
    const location = [review.city, review.province].filter(Boolean).join(' • ') || review.productTitle || storeName;
    const tag = inferTag(review);
    const date = formatDate(review.createdAt);

    return `
      <article class="dt-card dt-review-card">
        <div class="dt-review-card__top">
          <div class="dt-review-card__person">
            <div class="dt-review-card__avatar">${escapeHtml(getInitials(review.name))}</div>
            <div>
              <h3>${escapeHtml(review.name)}</h3>
              <p>${escapeHtml(location)}</p>
            </div>
          </div>
          ${review.verified ? '<span class="dt-review-card__verified">Compra verificada</span>' : ''}
        </div>

        <div class="dt-review-card__stars" aria-label="${review.rating} de 5 estrelas">${buildStars(review.rating)}</div>

        ${lines
          .map(
            (line) => `
              <div class="dt-review-card__qa">
                <span class="dt-review-card__label">${escapeHtml(line.label)}</span>
                <div class="dt-review-card__text">${escapeHtml(line.text)}</div>
              </div>
            `
          )
          .join('')}

        <div class="dt-review-card__bottom">
          <span class="dt-review-card__tag">${escapeHtml(tag)}</span>
          <span>${escapeHtml(date)}</span>
        </div>
      </article>
    `;
  }

  function buildAnswerLines(review) {
    const lines = [];

    if (review.title) {
      lines.push({
        label: 'Como foi a experiencia?',
        text: review.title
      });
    }

    if (review.body) {
      lines.push({
        label: review.title ? 'O que mais chamou atencao?' : 'Comentario',
        text: review.body
      });
    }

    if (!lines.length) {
      lines.push({
        label: 'Comentario',
        text: 'Cliente deixou uma avaliacao sem texto adicional.'
      });
    }

    return lines;
  }

  function inferTag(review) {
    const source = `${review.title} ${review.body}`.toLowerCase();
    if (source.includes('entrega') || source.includes('prazo') || source.includes('rapid')) {
      return 'Entrega elogiada';
    }
    if (source.includes('atendimento') || source.includes('suporte') || source.includes('resposta')) {
      return 'Atendimento elogiado';
    }
    if (source.includes('qualidade') || source.includes('acabamento') || source.includes('tecido')) {
      return 'Qualidade percebida';
    }
    if (source.includes('preco') || source.includes('valor') || source.includes('custo')) {
      return 'Otimo custo-beneficio';
    }
    return review.rating >= 5 ? 'Experiencia encantadora' : 'Experiencia positiva';
  }

  function buildCountsFromReviews(reviews) {
    const counts = { 5: 0, 4: 0, 3: 0, 2: 0, 1: 0 };
    reviews.forEach((review) => {
      const rating = clampRating(review.rating);
      if (counts[rating] != null) counts[rating] += 1;
    });
    return counts;
  }

  function buildStars(rating) {
    const rounded = Math.max(0, Math.min(5, Math.round(Number(rating) || 0)));
    return `${'★'.repeat(rounded)}${'☆'.repeat(5 - rounded)}`;
  }

  function clampRating(value) {
    const numeric = Number(value || 0);
    if (Number.isNaN(numeric)) return 0;
    return Math.max(0, Math.min(5, Math.round(numeric)));
  }

  function formatDate(value) {
    if (!value) return 'Data nao informada';
    const parsed = new Date(value);
    if (Number.isNaN(parsed.getTime())) return safeText(value);
    return DATE_FORMATTER.format(parsed);
  }

  function getInitials(name) {
    return String(name || 'Cliente')
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part.charAt(0).toUpperCase())
      .join('');
  }

  function createPageButton(label, page, isActive) {
    return `<button class="dt-pagination__button${isActive ? ' is-active' : ''}" type="button" data-page="${page}">${escapeHtml(label)}</button>`;
  }

  function buildErrorMessage(error) {
    if (error && error.status === 404) {
      return 'O cache do Judge.me retornou 404. Ative Platform-independent Review Widgets em Settings > Advanced, confira o Shop domain e o Public API Token, e lembre que a Reviews Page oficial pode depender do plano da conta.';
    }

    if (error && error.message === 'cache_empty') {
      return 'O cache do Judge.me respondeu sem reviews aproveitaveis para esta pagina.';
    }

    return 'Nao foi possivel carregar as avaliacoes do Judge.me pelo cache oficial agora.';
  }

  function ensureJudgeMePreloader() {
    if (document.querySelector('script[data-judgeme-preloader]')) return;
    const script = document.createElement('script');
    script.src = 'https://cdnwidget.judge.me/widget_preloader.js';
    script.async = true;
    script.dataset.judgemePreloader = 'true';
    document.head.appendChild(script);
  }

  function normalizeText(value) {
    return safeText(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function safeText(value) {
    return String(value == null ? '' : value).trim();
  }

  function formatNumber(value) {
    return new Intl.NumberFormat('pt-BR').format(Number(value) || 0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
